import { z } from 'zod';
import { LocalStorage } from '@mentimeter/storage';
import { DEPRECATED_SPLIT_KEY_PREFIX, VISITOR_DATA_PREFIX } from '../constants';

export const DEFAULT_COUNTRY = 'none' as const;
export const COUNTRY_KEY = 'country' as const;
export const COUNTRY_SCHEMA = z
  .string()
  .regex(/^[A-Z]{2}$/)
  .nullable();
export type Country = z.infer<typeof COUNTRY_SCHEMA>;

export function getCountryFromLocalStorage(): Country {
  const country =
    LocalStorage.getItem(VISITOR_DATA_PREFIX + COUNTRY_KEY) ??
    LocalStorage.getItem(DEPRECATED_SPLIT_KEY_PREFIX + COUNTRY_KEY);

  const parsedCountry = COUNTRY_SCHEMA.safeParse(country);

  if (!parsedCountry.success) {
    return null;
  }

  return parsedCountry.data;
}

export function setCountryInLocalStorage(country: string | null): void {
  if (country && COUNTRY_SCHEMA.safeParse(country).success) {
    LocalStorage.setItem({
      key: VISITOR_DATA_PREFIX + COUNTRY_KEY,
      value: country,
      type: 'functional',
    });
  }
}
